import * as React from 'react';

import MaterialCostSource from 'ab-enums/materialCostSource.enum';

import styles from './styles.module.scss';

const LETTER_FOR_SOURCE: { [source in MaterialCostSource]: string; } = {
	[MaterialCostSource.COMPANY]: 'C',
	[MaterialCostSource.COMPANY_MATERIAL]: 'M',
	[MaterialCostSource.JOB]: 'J',
	[MaterialCostSource.JOB_MATERIAL]: 'JM',
};

interface OwnProps {
	className?: string;
	rateSource: MaterialCostSource;
}

type Props = OwnProps;

const MaterialRateSource: React.FC<Props> = (props) => {
	const { className: externalClassName = '', rateSource } = props;

	const letter = LETTER_FOR_SOURCE[rateSource];

	const className = `${styles.materialRateSource} ${styles[rateSource]} ${externalClassName}`;

	return (
		<div className={className}>{letter}</div>
	);
};

export default MaterialRateSource;
